import { create } from "zustand";
import { authApi } from "../api";

interface User {
  id: number;
  username: string;
  email: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (identifier: string, password: string) => Promise<void>;
  logout: () => void;
  clearError: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: JSON.parse(localStorage.getItem("user") || "null"),
  token: localStorage.getItem("token"),
  isAuthenticated: !!localStorage.getItem("token"),
  isLoading: false,
  error: null,

  login: async (identifier, password) => {
    set({ isLoading: true, error: null });
    try {
      //console.log({ identifier, password });
      const response = await authApi.login(identifier, password);
      console.log(await authApi.login(identifier, password));
      console.log({ response });
      const { jwt, user } = response.data;

      localStorage.setItem("token", jwt);
      localStorage.setItem("user", JSON.stringify(user));

      set({ user, token: jwt, isAuthenticated: true, isLoading: false });
    } catch (err: any) {
      console.log(err.response);
      const message =
        err.response?.data?.error?.message || "Ошибка авторизации";
      set({ error: message, isLoading: false });
      throw new Error(message);
    }
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    set({ user: null, token: null, isAuthenticated: false });
  },

  clearError: () => set({ error: null }),
}));
